<template>
  <v-card-text>
      <div>
        <v-form
          ref="form"
          v-model="valid"
        >
          <v-text-field
            v-model="mobile"
            label="Mobile Number*"
            light
            required
            outlined
          />

          <v-text-field
            v-model="email"
            label="Email Address*"
            light
            required
            outlined
          />

          <v-text-field
            v-model="companyName"
            label="Company Name*"
            light
            required
            outlined
          />

          <v-text-field
            v-model="firstName"
            label="First Name*"
            light
            required
            outlined
          />

          <v-text-field
            v-model="lastName"
            light
            label="Last Name*"
            required
            outlined
          />
        </v-form>
      </div>
      <v-card-actions>
        <v-btn color="orange darken-3" x-large block
          :disabled="isSubmitDisabled"
          dark
          class="rounded-xl"
          @click.prevent="onFormSubmit()"
          >
           Confirm
        </v-btn>
      </v-card-actions>
  </v-card-text>
</template>

<script>
import axios from 'src/app-axios'

export default {
  data: () => ({
    valid: false,
    companyName: '',
    firstName: '',
    lastName: '',
    email: '',
    mobile: ''
  }),

  computed: {
    hasEmptyFields () {
      return this.mobile.trim() === '' ||
         this.firstName.trim() === '' ||
         this.lastName.trim() === ''
    },
    isSubmitDisabled () {
      return this.hasEmptyFields
    }
  },

  methods: {
    onFormSubmit () {
      var config = {
        headers: {
          'x-organization-id': this.$store.getters['swiftuser/getOrganizationId'],
          'x-digi-board-id': this.$store.getters['swiftuser/getDigiBoardId']
        }
      }
      axios.post('api/swift-checkin/user', {
        first_name: this.firstName,
        last_name: this.lastName,
        mobile: this.mobile,
        email: this.email,
        company: this.companyName
      }, config).then(response => {
        this.$store.dispatch('swiftuser/onAddUser', response.data)
        this.$emit('stepSuccess')
      })
    }
  }
}
</script>
